import React, { useRef, useEffect } from "react";
import "../css/carinsurance.css";
import carinsuranceimg from "../assets/carinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from "react-helmet-async";

const CarInsurance = () => {
  const API_URL = process.env.REACT_APP_Dashboard_API_URL;
  const imageRefs = useRef([]);
  const imageSources = [
    carinsuranceimg,
    tollfreenumberimg
  ];

  useEffect(() => {
    if (imageRefs.current.length > 0) {
      let index = 0;

      const showNextImage = () => {
        imageRefs.current.forEach((img, i) => {
          if (img) img.style.display = i === index ? "block" : "none";
        });

        index++;
        if (index >= imageRefs.current.length) index = 0;
        setTimeout(showNextImage, 3000);
      };

      showNextImage();
    }
  }, []);

  const handleSubmit = async (data) => {
    const inquriyData = new FormData();
    inquriyData.append("Name", data.Name);
    inquriyData.append("Email", data.Email);
    inquriyData.append("PreferredDate", data.Date);
    inquriyData.append("PreferredTime", data.Time);
    inquriyData.append("MobileNo", data.MobileNo);
    inquriyData.append("Status", "New");
    inquriyData.append("UserId", data.Id);
    inquriyData.append("InquiryType", "Insurance Inquiries");
    inquriyData.append("PolicyType", "Car Insurance");
    inquriyData.append("IsLoggedIn", data.isLoggedIn);
    inquriyData.append("Otp", data.OTP);

    try {
      const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("Error submitting consultation request:", error);
      return {
        status: 500,
        data: {
          success: false,
          message: error.response?.data?.message,
        },
      };
    }
  };

  return (
    <div className="carinsurance-container">
      <Helmet>
        <title>Motor Insurance Consultation | Drive Worry-Free Today</title>
        <meta
          name="description"
          content="Talk to experts for motor insurance consultation tailored to your vehicle and budget. Protect yourself on the road with the right cover."
        />
        <meta
          name="keywords"
          content="motor insurance consultation, car insurance advice, vehicle insurance India, compare motor insurance, expert car insurance help"
        />
        <link rel="canonical" href="https://policysamjho.com/car-insurance-consultation/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Motor Insurance Consultation",
            "description": "Expert consultation for motor insurance policies. Get the right coverage and protect your vehicle with clear, honest advice from Policy Samjho.",
            "provider": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com/"
            },
            "serviceType": "Car Insurance Advice",
            "areaServed": "IN",
            "url": "https://policysamjho.com/car-insurance-consultation/",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9584484800",
              "email": "info@policysamjho.com",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>

      <div className="carinsurance-hero-container">
        <div className="carinsurance-hero-text-box">
          <h1>
            <span style={{ color: "#192437" }}>Motor Insurance </span>
            <span style={{ color: "#F5A526" }}>Consultation</span>
          </h1>
          <p
            style={{
              color: "black",
              fontWeight: "600",
              fontSize: "18px",
              textAlign: "justify",
            }}
          >
            Get comprehensive protection against damages, theft, and third-party liabilities with a reliable car insurance policy.
          </p>
        </div>

        <div className="carinsurance-hero-image-box carinsurance-imgslider">
          {imageSources.map((image, index) => (
            <img
              key={index}
              ref={(el) => (imageRefs.current[index] = el)}
              src={image}
              className="carinsurance-sliderimg"
              alt={`carinsurance-slide-${index}`}
              style={{ display: index === 0 ? "block" : "none" }}
            />
          ))}
        </div>
      </div>

      <div className="carinsurance-containform-container">
        <div className="col-md-6 carinsurance-info">
          <h2 className="carinsurance-heading">
            <span style={{ color: "#192437" }}>What is </span>
            <span style={{ color: "#F5A526" }}>Car Insurance?</span>
          </h2>
          <p className="carinsurance-text">
            Car insurance provides financial protection by covering damages, accidents, theft,
            and third-party liabilities for all types of cars. It ensures a stress-free driving experience.
          </p>

          <h2 className="carinsurance-subheading">
            <span style={{ color: "#192437" }}>Why is </span>
            <span style={{ color: "#F5A526" }}>Car Insurance Important?</span>
          </h2>
          <ul className="carinsurance-benefits">
            <li className="insurancepoints">Covers accidental damage</li>
            <li className="insurancepoints">Third-party liability coverage</li>
            <li className="insurancepoints">Protection from theft and loss</li>
            <li className="insurancepoints">Cashless repairs at network garages</li>
          </ul>

          <h2 className="carinsurance-subheading">
            <span style={{ color: "#192437" }}>Comprehensive Coverage & </span>
            <span style={{ color: "#F5A526" }}>Insurance Benefits</span>
          </h2>
          <p className="carinsurance-text spaced-text">
            Car insurance ensures financial security by covering a wide range of risks,
            including accidental damage, theft, third-party liabilities, and natural calamities.
            It provides peace of mind while driving and minimizes financial stress.
            Policies often include personal accident benefits, roadside assistance, and
            cashless claims at network garages. Many insurance plans also offer add-ons like
            engine protection, zero depreciation, and coverage for accessories.
          </p>
        </div>

        <div>
          <h4 className="consultationform-heading">
            <span style={{ color: "#192437" }}>Get a Free </span>
            <span style={{ color: "#F5A526" }}> Car Insurance Quote </span>
          </h4>
          <ConsultationForm onSubmit={handleSubmit} />
        </div>
      </div>

      <PoliciesSlider category="Car Insurance" />
      <ChatbotAi />
    </div>
  );
};

export default CarInsurance;